import React, { useState, useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import { Row, Col, Modal } from 'react-bootstrap';

import { withRFSToken } from '../../../Services/axios.js';
import { toast } from 'react-toastify';

const DownloadGrid = ({ onClose, download_sec }) => {
    const isMounted = useRef(false);

    const CentreOptions = [
        { label: 'Dnata', value: 'Dnata' }
    ];

    const [isModalOpen, setIsModalOpen] = useState(true);
    const [downloadData, setDownloadData] = useState({});
    const options = [];

    const fetchPref = async () => {
        try {
            const res = await withRFSToken.get('forwarder-user-setting/get-setting', {});
            if (res.data.response_code === 200) {
                const { inspection_center } = res.data.response_data.settings || {};
                setDownloadData(prev => ({
                    ...prev,
                    inspection_center: inspection_center
                }));
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    useEffect(() => {
        if (isMounted.current) return;
        fetchPref();
        isMounted.current = true;
    }, []);

    const exportToExcel = async () => {
        let endPoint = '';
        let payload = {};
        switch (true) {
            case download_sec == 'Nvwa':
                endPoint = 'shipment/download-shipment-record';
                payload = {
                    tab: download_sec,
                    ...downloadData
                }
                break;
            default:
                endPoint = '';
                payload = {};
        }
        // console.log('payload', payload);

        try {
            const res = await withRFSToken.post(endPoint, payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    },
                    responseType: 'blob',
                }
            )
                .then(response => {
                    const now = new Date();
                    const formattedDateTime = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
                    const blob = new Blob([response.data], { type: response.headers['content-type'] });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `${formattedDateTime} Downloaded`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    handleModalClose();
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        onClose();
    };
    return (
        <>
            {/* {console.log('download_sec', download_sec)} */}
            <Modal show={isModalOpen} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>Download Filter</h3>
                    <p>Download the document as a selected option</p>
                    <div className='my-4 '>
                        {download_sec == 'Nvwa' &&
                            <Form.Group as={Row} className='mb-2'>
                                <Col sm="12">
                                    <Form.Label>Requested Start Date</Form.Label>
                                    <Form.Control
                                        // type="datetime-local"
                                        type="date"
                                        name='start_date'
                                        onChange={(e) => setDownloadData({ ...downloadData, start_date: e.target.value })}
                                    />
                                </Col>
                                <Col sm="12">
                                    <Form.Label>Requested End Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name='end_date'
                                        onChange={(e) => setDownloadData({ ...downloadData, end_date: e.target.value })}
                                    />
                                </Col>
                                <Col sm="12">
                                    <Form.Label>Inspection Centre</Form.Label>
                                    <Select
                                        options={CentreOptions}
                                        onChange={(selected) => setDownloadData({ ...downloadData, inspection_center: selected.value })}
                                        placeholder="Inspection centre"
                                        name="inspection_center"
                                        value={CentreOptions.find((option) => option.value == downloadData.inspection_center) || null}
                                    />
                                </Col>
                            </Form.Group>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={exportToExcel}>
                        Download
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DownloadGrid;